<template>
  <div class="page">
    <div class="module_one">
      <div class="module_one-video">
        <img
          class="module_one-video-bg"
          src="https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_4cdca6285c3c4cb68618e28544ef87d1.png"
          alt=""
        />
        <player-video
          ref="videoOne"
          :isPlay.sync="isPlay"
          padding="0.11rem 0.08rem"
          :liveInfo="liveInfo"
          :poster="liveInfo.live.kvImg"
          @childData="updateData"
        ></player-video>
        <img
          class="KV"
          v-show="KV"
          @click="KVimg()"
          src="https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_fd9af4ce330f43db83cfa4fe0695a14b.jpg"
          alt=""
        />
      </div>
      <div class="module_one-btns">
        <!--   v-show="
            liveInfo.live.languageStatus &&
            parseInt(liveInfo.live.languageSpecies)
          " -->
        <div v-show="this.liveInfo.live.remark">
          <img v-show="!imgBtn" :src="this.liveInfo.live.remark.split('/')[this.liveInfo.live.remark.split('/').length - 1] == 1 ? btn5 : this.liveInfo.live.remark.split('/')[this.liveInfo.live.remark.split('/').length - 1] == 2 ? btn6 : btn7" alt="" />
          <a href="https://wx.vzan.com/live/tvchat-1972777671?v=1693748766301">
            <img
              v-show="imgBtn"
              src="https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_55b3ef56d89c4fa580cee2801ca053b6.png"
              alt=""
          /></a>
          <!-- remark备注 语言切换按钮 -->
          <div class="2btn" v-show="inBtn2">
            <div class="module_one-btns-btn" @click="handleTab('tab', 0)"></div>
            <div class="module_one-btns-btn" @click="handleTab('tab', 1)"></div>
          </div>
          <div class="btn3" v-show="inBtn1">
            <div
              :class="['module_one-btns-btn1', this.liveInfo.live.remark.split('/').length === 3 ? 'two' : '']"
              @click="handleTab('tab', 0)"
            ></div>
            <div
              :class="['module_one-btns-btn1', this.liveInfo.live.remark.split('/').length === 3 ? 'two' : '']"
              @click="handleTab('tab', 1)"
            ></div>
            <div v-if="this.liveInfo.live.remark.split('/').length === 4"
              class="module_one-btns-btn1"
              @click="handleTab('tab', 2)"
            ></div>
            <!-- <div
              class="module_one-btns-btn1"
              @click="handleTab('tab', 3)"
            ></div> -->
          </div>
        </div>
      </div>
      <div class="module_one-href">
        <!-- <a href="https://live.photoplus.cn/live/67049967">点击查看精彩瞬间</a> -->
      </div>
    </div>
    <div class="module_two">
      <x-swiper
        :liveId.sync="liveId"
        :videoList="allList.length ? allList : liveList"
      ></x-swiper>
    </div>
    <div class="module_three">
      <div style="min-height: 0.3rem; margin-bottom: 0.22rem">
        <div class="module_three-top">
          <div class="module_three-top-btn" @click="handleTab('tab1', 0)">
            <img :src="tab1 === 0 ? btn1 : btn4" alt="" />
            <div
              :class="`module_three-top-btn-text ${
                tab1 !== 0 ? 'module_three-top-btn-active' : ''
              }`"
            >
              9月21日
            </div>
          </div>
          <!-- <div
            class="module_three-top-btn"
            style="margin-left: -0.04rem"
            @click="handleTab('tab1', 1)"
          >
            <img :src="tab1 === 1 ? btn3_1 : btn3_2" alt="" />
            <div
              :class="`module_three-top-btn-text ${
                tab1 !== 1 ? 'module_three-top-btn-active' : ''
              }`"
            >
              9月22日
            </div>
          </div> -->
          <!-- <div
            class="module_three-top-btn"
            style="margin-left: -0.04rem"
            @click="handleTab('tab1', 2)"
          >
            <img :src="tab1 === 2 ? btn3_1 : btn3_2" alt="" />
            <div
              :class="`module_three-top-btn-text ${
                tab1 !== 2 ? 'module_three-top-btn-active' : ''
              }`"
            >
              9月9日
            </div>
          </div> -->
          <div class="module_three-top-btn" @click="handleTab('tab1', 1)">
            <img :src="tab1 === 1 ? btn3 : btn2" alt="" />
            <div
              :class="`module_three-top-btn-text ${
                tab1 !== 1 ? 'module_three-top-btn-active' : ''
              }`"
            >
              9月22日
            </div>
          </div>
        </div>
      </div>
      <div class="module_three-swiper" style="min-height: 1.53rem">
        <swiper :liveId.sync="liveId" :videoList="liveList"></swiper>
      </div>
    </div>
    <div class="module_four">
      <img
        src="https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_04ac51792fa14a718c2e06102a663514.png"
        alt=""
      />
      <a
        class="module_four-url"
        href="https://h5.sauos.com/project/dbkj/202002/"
      ></a>
      <a
        class="module_four-url"
        href="https://h5.sauos.com/project/dbkj/2021jszydh/ "
      ></a>
      <a
        class="module_four-url"
        href="https://h5.sauos.com/project/dbkj/2022jszydh/"
      ></a>
      <a
        class="module_four-url"
        href="https://h5.sauos.com/project/dbkj/2023jszydh/"
      ></a>
      <a
        class="module_four-url"
        href="https://2024innomatch.sauos.net/"
      ></a>
      <!-- <a
        class="module_four-url"
        href="https://h5.sauos.com/project/dbkj/2024jszydh/"
      ></a> -->
    </div>

    <div class="module_five">
      <div class="module_five-video">
        <x-player-video
          ref="videoTwo"
          :isPlay.sync="isPlayTwo"
        ></x-player-video>
      </div>
      <div class="module_five-bottom">
        <a href="https://www.innomatch.net">
          <img
            src="https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_90dd98eaf9ea46fa82932d8173bee63d.png"
            alt=""
          />
        </a>
        <a href="https://xjt.pujiangforum.cn/">
            <img class="img2" style="margin: auto;"
              src="../../../assets/avatar.png"
              alt=""
            />
            <span style="display: inline-block; text-align: center; width: 100%; color: #f1f1f1;margin-top: 0.05rem; font-size: 0.12rem;">小江豚智能体</span>
          </a>
        <!-- <a href="https://www.innomatch.net/os/rank_activity/rule">
          <img
            class="img2"
            src="https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_d97e2556db4a4e0788da128f25b6d7f1.png"
            alt=""
          />
        </a> -->
      </div>
    </div>
  </div>
</template>

<script>
// import wx from 'weixin-js-sdk'
import PlayerVideo from '@/components/video/index'
import XPlayerVideo from '@/components/video/index-two'
import Swiper from '@/components/swiper/index'
import {
  getLiveList,
  getLiveInfo,
  getShareConfig
  // wechatParam,
} from '@/api/api.js'
import XSwiper from '@/components/x-swiper/index'
import wechat from '@/utils/wxShare.js'
// import getWechatConfig from '@/utils/getWechatConfig'
export default {
  components: { PlayerVideo, XPlayerVideo, Swiper, XSwiper },
  data() {
    return {
      tab: 0,
      tab1: 0,
      btn1: 'https://homesaassauos.oss-cn-shanghai.aliyuncs.com/home/qqjszydh/2025/btn1.png',
      btn2: 'https://homesaassauos.oss-cn-shanghai.aliyuncs.com/home/qqjszydh/2025/btn2.png',
      btn3: 'https://homesaassauos.oss-cn-shanghai.aliyuncs.com/home/qqjszydh/2025/btn2.png',
      btn3_1:
        'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_54c1ee3162154c2183d25bcef87c1557.png',
      btn3_2:
        'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_c2604ae7bb7841e0812f99fb31414873.png',
      btn4: 'https://homesaassauos.oss-cn-shanghai.aliyuncs.com/home/qqjszydh/2025/btn1.png',
      btn5: 'https://homesaassauos.oss-cn-shanghai.aliyuncs.com/home/qqjszydh/2025/lang3.png',
      btn6: 'https://homesaassauos.oss-cn-shanghai.aliyuncs.com/home/qqjszydh/2025/lang2.png',
      btn7: 'https://homesaassauos.oss-cn-shanghai.aliyuncs.com/home/qqjszydh/2025/lang1.png',
      isPlay: false,
      isPlayTwo: false,
      ids: [
        { chinese: 372, english: 325 },
        { chinese: 373, english: 324 }
        // { chinese: 362, english: 324 },
        // { chinese: 363, english: 324 }
      ],
      liveId: null,
      liveInfo: {
        live: {},
        liveStream: {}
      },
      imgBtn: '',
      inBtn: '',
      inBtn1: '',
      inBtn2: '',
      inb1: '',
      inb2: '',
      inb3: '',
      inb4: '',
      KV: true,
      allList: [],
      liveList: []
    }
  },
  mounted() {
    console.log('phone')
    this.handleTab()
    this.share()
    // getWechatConfig()
  },
  watch: {
    liveId(n, o) {
      // console.log(n, o)
      if (n !== o) {
        this.tab = 0
        this.getLiveInfo(n)
      }
      if (n === 1555) {
        this.imgBtn = true
      }
    },
    isPlay(n) {
      console.log(n)
      if (n) {
        this.$refs.videoTwo.pause()
        this.isPlayTwo = false
      }
    },
    isPlayTwo(n) {
      console.log(n)
      if (n) {
        this.$refs.videoOne.pause()
        this.isPlay = false
      }
    }
  },
  methods: {
    updateData(value) {
      this.KV = value
    },
    KVimg() {
      this.KV = false
    },
    share() {
      getShareConfig({
        url: window.location.href,
        userId: 258,
        typeId: 0,
        keyId: 258
      }).then((res) => {
        // console.log(res)
        // var options = res.data
        // console.log(options)
        // Object.assign(options, {
        //   share_title: '2023全球技术转移大会（InnoMatch EXPO）'
        // })
        // Object.assign(options, {
        //   share_info: '直播进行时！'
        // })
        // Object.assign(options, {
        //   appid: 'wxab023badfd6bf4b3'
        // })
        // Object.assign(options, {
        //   share_thumb:
        //     'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_ec5d011b96b04a108016ebffb919a5a3.jpg'
        // })
        wechat.share(res.data)
        // console.log(options)
      })
      // this.$axios
      //   .get('https://qmjs.kj.9service.net/wx/wechatParam', {
      //     params: {
      //       url: window.location.href
      //     }
      //   })
      //   .then((res) => {
      //     console.log(res.data)
      //     let options = res.data.data
      //     wechat.share(options)
      //   })
    },
    handleTab(value, tab) {
      // console.log(value, tab)
      if (value && this[value] === tab) return
      this[value] = tab
      switch (value) {
        case 'tab':
          if (this.inBtn) {
            if (this.tab === 0) {
              if (this.inb1) {
                this.getLiveInfo(this.inb1)
              }
            } else if (this.tab === 1) {
              if (this.inb2) {
                this.getLiveInfo(this.inb2)
              }
            } else if (this.tab === 2) {
              if (this.inb3) {
                this.getLiveInfo(this.inb3)
              }
            } else if (this.tab === 3) {
              if (this.inb4) {
                this.getLiveInfo(this.inb4)
              }
            }
          } else {
            const id = parseInt(this.liveInfo.live.remark)
            console.log(id)
            this.getLiveInfo(id)
          }
          break
        case 'tab1':
          this.tab = 0
          if (this.tab1 === 0) {
            const id = this.ids[0].chinese
            this.getLiveList(id)
          } else if (this.tab1 === 1) {
            const id = this.ids[1].chinese
            this.getLiveList(id)
          } else if (this.tab1 === 2) {
            const id = this.ids[2].chinese
            this.getLiveList(id)
          } else if (this.tab1 === 3) {
            const id = this.ids[3].chinese
            this.getLiveList(id)
          }
          break
        // eslint-disable-next-line no-fallthrough
        default:
          this.getLiveList()
          break
      }
    },
    // 默认查询第一天的项目下直播列表
    getLiveList(id = 372) {
      getLiveList({ homeId: id, page: 1, limit: 999, liveType: 2 }).then(
        (res) => {
          // console.log(res)
          this.liveList = res.page.list
          console.log(this.liveList)
          this.liveId = this.liveList[0].liveId
          const time = new Date().getTime()
          this.allList = []
          this.liveList.forEach((t) => {
            if (t.livetime * 1000 <= time) {
              this.allList.push(t)
            }
          })
        }
      )
    },
    getLiveInfo(id) {
      const data = { openId: 'openId' }
      getLiveInfo(data, id).then((res) => {
        this.liveInfo = res.data

        var btn = this.liveInfo.live.remark
        this.inBtn = btn.includes('/') // 判断备注中是否存在‘/’，存在返回true， 在直播间备注上填写其他语言直播间id，双语只填另一种语言直播间id，多种语言填写全部id，以‘/’分隔
        if (this.inBtn && id !== 1555) {
          this.inBtn1 = true
          this.inBtn2 = false
        } else if (!this.inBtn && id !== 1555) {
          this.inBtn2 = true
          this.inBtn1 = false
        } else {
          this.inBtn2 = false
          this.inBtn1 = false
        }
        var arr = btn.split('/')
        // console.log(arr[0] + '<', arr[1] + '<', arr[2] + '<', arr[3] + '<')
        this.inb1 = arr[0]
        this.inb2 = arr[1]
        this.inb3 = arr[2]
        this.inb4 = arr[3]
        // console.log(this.inBtn.includes('/'))
        // console.log(this.liveInfo)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
$color-f: #fff;
$color_a: #a6939a;
$page_padding_bottom: 0.5rem;
$margin_bottom-one: 0.3rem;
$module_one_padding_top: 3.16rem;
$width_video: 3.2rem;
$width_btn_one: 1.7rem;
$width_btn_one-top: 0.12rem;
$module-width: 95%;
$module_two_margin-top: 1rem;
$module_two-left-width: 1.3rem;
$module_two-right-width: 1rem;

.page {
  width: 100%;
  background: url('https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_9e9601d0bbb846548bc3fc259e62c1f0.jpg') center/cover
    no-repeat;
  // background-size: cover;
  padding-bottom: $page_padding_bottom;
  img {
    width: 100%;
  }
  .module_one {
    padding-top: $module_one_padding_top;
    &-video {
      width: $width_video;
      margin: auto;
      margin-bottom: -0.15rem;
      margin-top: 0.15rem;
      position: relative;
    }
    &-btns {
      margin: auto;
      width: $width_btn_one;
      margin-top: $width_btn_one-top;
      min-height: 0.18rem;
      position: relative;
      &-btn {
        width: 50%;
        height: 100%;
        position: absolute;
        // border: 1px solid yellow;
        cursor: pointer;
        top: 0;
        left: 0;
      }
      &-btn:nth-of-type(2) {
        top: 0;
        left: 50%;
      }
      &-btn1 {
        width: 32%;
        height: 100%;
        position: absolute;
        // border: 1px solid red;
        cursor: pointer;
        top: -0.03rem;
        left: 0;
      }
      &-btn1:nth-of-type(2) {
        width: 30%;
        left: 33%;
      }
      &-btn1:nth-of-type(3) {
        width: 35%;
        left: 65%;
      }
      &-btn1.two, &-btn1:nth-of-type(2).two {
          width: 50%;
        }
        &-btn1:nth-of-type(2).two {
          left: 50%;
        }
      // &-btn1:nth-of-type(4) {
      //   left: 70%;
      // }
    }
    &-href {
      font-size: 0.12rem;
      text-align: center;
      margin-top: 0.19rem;
      a {
        color: $color-f !important;
      }
    }
  }
  .module_two {
    width: $module-width;
    margin: auto;
    margin-top: $module_two_margin-top;
    margin-bottom: $margin_bottom-one;
  }
  .module_three {
    width: $module-width;
    margin: auto;
    margin-bottom: $margin_bottom-one;
    &-top {
      display: flex;
      justify-content: space-between;
      &-btn {
        flex: 1;
        position: relative;
        &-active {
          color: $color_a !important;
        }
        &-text {
          position: absolute;
          width: 100%;
          top: 0;
          left: 0;
          display: flex;
          color: $color-f;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
  .ad {
    position: absolute;
    width: 100px;
    height: 100px;
    border: 1px solid red;
  }
  .module_four {
    position: relative;
    margin-bottom: $margin_bottom-one;
    &-url {
      position: absolute;
      width: 0.4rem;
      height: 0.4rem;
    }
    &-url:nth-of-type(1) {
      top: 0.6rem;
      left: 0.28rem;
    }
    &-url:nth-of-type(2) {
      top: 0.7rem;
      left: 1rem;
    }
    &-url:nth-of-type(3) {
      top: 0.75rem;
      left: 1.6rem;
    }
    &-url:nth-of-type(4) {
      top: 0.25rem;
      left: 2rem;
    }
    &-url:nth-of-type(5) {
      top: 0.18rem;
      left: 2.55rem;
    }
  }
  .module_five {
    width: $module-width;
    margin: auto;
    &-video {
      height: 0.9rem;
      border: 2px solid #f0f0f0;
    }
    &-bottom {
      display: flex;
      justify-content: space-between;
      padding-left: 0.2rem;
      margin-right: 0.3rem;
      margin-top: 0.3rem;
      a {
        display: block;
        height: 0.7rem;
        // border: 1px solid;
        img {
          width: auto;
          height: 90%;
          // padding-top: 0.03rem;
        }
        .img2 {
          height: 60%;
          padding-top: 0rem;
        }
      }
    }
  }
}
.KV {
  position: absolute;
  width: 95% !important;
  top: 5%;
  z-index: 999;
  left: 2.5%;
}
.WxBtn {
  display: flex;
  width: 100%;
  padding: 0.3rem 0;
  justify-content: space-around;
  img {
    width: 50%;
    height: 100%;
  }
  .imgone {
    width: 44%;
  }
}
</style>
